import React from "react";
import { t } from "ttag";

import styles from "./SearchAreaButton.module.scss";

export const SearchAreaButton = (props: { onPress: () => void }) => (
    <button type="button" className={styles.button} onClick={props.onPress}>
        {t`Search this Area`}
    </button>
);
